import React, {useRef, useLayoutEffect} from 'react';
import type {
  ColorTypes,
  IconType,
  IconSize,
} from '@spaced-out/ui-design-system';

import {Checklist, ChecklistProgressBar} from '@spaced-out/ui-design-system';

import type {
  ListWidgetPayload,
  ListWidgetStepStatus,
  ActionEvent,
} from 'src/components/agentic-ui/types';


interface ListWidgetProps {
  payload: ListWidgetPayload;
  publishMessageAction?: (action: ActionEvent) => void;
  onResize?: () => void;
}

function getIconForStatus(status: ListWidgetStepStatus): {
  iconLeftName: string;
  iconLeftType: IconType;
  iconLeftColor?: ColorTypes;
  iconLeftSize: IconSize;
} {
  const iconObj = {
    iconLeftSize: 'small' as const,
    iconLeftType: 'solid' as const,
  };
  switch (status) {
    case 'completed':
      return {
        ...iconObj,
        iconLeftName: 'check-circle',
        iconLeftColor: 'success',
      };
    case 'info':
      return {
        ...iconObj,
        iconLeftName: 'info-circle',
        iconLeftColor: 'tertiary',
      };
    default:
      return {
        ...iconObj,
        iconLeftName: 'warning',
      };
  }
}

export function ListWidget({
  payload,
  publishMessageAction,
  onResize,
}: ListWidgetProps) {
  const {title, progress, steps} = payload;

  const listItems = steps.map((step) => {
    const icon = getIconForStatus(step.status);
    return {
      ...icon,
      key: step.id,
      label: step.title,
      onExpand: () => {
        if (publishMessageAction) {
          const {name, product, payload} = step.event;
          publishMessageAction({
            product,
            event: name,
            payload,
          });
        }
      },
    };
  });

  const progressBar = progress ? (
    <ChecklistProgressBar
      showLoadingBar
      completedItems={
        steps.filter((step) => step.status === 'completed').length
      }
      totalItems={progress.total}
    />
  ) : null;

  return (
    <Checklist
      title={title}
      listItems={listItems}
      rightSlot={progressBar}
      isOpen={true}
    />
  );
}
